/**
 *
 *  ? url pada submenu menggunakan naming routes,
 *  ? jadi tidak perlu dibuat format url lengkap
 */
export default [
  {
    icon: "UserIcon",
    menu: "Roles",
    url: "pusdatin-roles",
  },
  {
    icon: "UserIcon",
    menu: "Login As",
    url: "pusdatin-login-as",
  },
];
